module.exports = __webpack_public_path__ + "img/srgt.15d72d75.png";